import { Role } from '@traton/devportal-rbac-common-lib';

/**
 * Admin role for announcement app
 * Has full access to all announcement operations
 */
export const announcementAdmin: Role = {
  name: 'announcement.admin',
};
